import React from "react";
import { smallprintContainer } from "./Smallprint.css";
import { usePromotionalBanner } from "packages/membership/components/PromotionalBanner/usePromotionalBanner";
import type { PromotionalBannerResponse } from "packages/membership/components/PromotionalBanner/types";
import { MarkdownContainer, Typography } from "@shared/ui.primitives";

const toSmallPrintContent = (
  promotionalBannerDetails: PromotionalBannerResponse
): string | null | undefined => {
  const contentMessages = promotionalBannerDetails.contentMessages;

  return contentMessages.find(
    (message) =>
      [
        "FREE_SHIPPING_AND_SAMPLES_MEMBERS",
        "FREE_SHIPPING_NON_MEMBERS"
      ].includes(message.type) && message.smallPrint
  )?.smallPrint;
};

export const Smallprint: React.FC = () => {
  const { promotionalBannerDetails, loading } = usePromotionalBanner();

  if (loading || !promotionalBannerDetails) {
    return null;
  }

  const smallPrintContent = toSmallPrintContent(promotionalBannerDetails);

  if (!smallPrintContent) {
    return null;
  }

  return (
    <div className={smallprintContainer} data-testid="Smallprint">
      <MarkdownContainer
        content={smallPrintContent}
        forceBlock
        tagOverrides={{
          a: {
            component: Typography,
            props: {
              as: "a",
              underline: true,
              variant: "smallprint-md"
            }
          },
          p: {
            component: Typography,
            props: {
              as: "p",
              variant: "smallprint-md"
            }
          }
        }}
      />
    </div>
  );
};
